import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Calendar, X } from "@piiqtechnologies/svg-icons";
import { PeekButton, PeekIconButton, PeekPaper, PeekStack, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
import ScheduleForm from "./ScheduleForm";
export const ScheduleButton = ({ isTableScheduleMode, selectedScanRequests }) => {
    const intl = useIntl();
    const theme = useTheme();
    const [showScheduleForm, setShowScheduleForm] = useState(false);
    const toggleScheduleForm = () => {
        setShowScheduleForm(!showScheduleForm);
        isTableScheduleMode(!showScheduleForm);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekButton, { size: "large", onClick: toggleScheduleForm, color: showScheduleForm ? "primary" : "info", variant: showScheduleForm ? "contained" : "outlined" },
            React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 1 },
                React.createElement(Calendar, { fontSize: "16px" }),
                React.createElement(PeekTypography, { variant: "h4" }, intl.formatMessage(messages.schedule)))),
        showScheduleForm && (React.createElement(PeekPaper, { sx: {
                position: "absolute !important",
                marginTop: `${theme.spacing(5)} !important`,
                marginLeft: `-${theme.spacing(3)} !important`,
                zIndex: 10,
            } },
            React.createElement(PeekIconButton, { onClick: toggleScheduleForm, bordered: false, sx: { position: "absolute", right: 20, top: 10 } },
                React.createElement(X, { width: 20, height: 20 })),
            React.createElement(ScheduleForm, { onConfirmSchedule: toggleScheduleForm, selectedScanRequests: selectedScanRequests })))));
};
export default ScheduleButton;
